import React, {useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {Modal} from 'react-bootstrap';
import {can} from '../../_common/components/Permissions';
import styles from './styles.module.scss';

const PopupDocsWarning = ({actionType, handleAction}) => {
  const [show, setShow] = useState(false);
  const handleShowModal = () => setShow(true);
  const handleCloseModal = () => setShow(false);
  const isEnabled = can('full', 'transfersByAgentPage');
  const prefix = 'transfersByAgent-popup-docs-warning';

  return (
    <>
      {actionType === 'create'
        ? (
          <button
            className={styles.primary}
            disabled={!isEnabled}
            onClick={() => handleShowModal()}
          >
            <FormattedMessage id={`transfersByAgent-popup-create-button`} defaultMessage={'New transfer'}/>
          </button>
        )
        : (
          <div
            className={isEnabled ? 'cursor-pointer' : 'opacity-30'}
            title={'עריכת העברה'}
            onClick={() => {
              if (isEnabled) {
                handleShowModal();
              }
            }}
          >✏️
          </div>
        )
      }
      <Modal show={show} onHide={handleCloseModal}>
        <Modal.Body>
          <h5 className={styles.headerText}>
            <FormattedMessage
              id={`${prefix}-message`}
              defaultMessage={'Please note this agent has a shortage of 101 forms, tax reconciliation or both, should I continue or cancel?'}
            />
          </h5>
          <div className={styles.actions}>
            <button
              className={styles.btnCancel}
              onClick={() => handleCloseModal()}
            >
              <FormattedMessage id={`${prefix}-btn-cancel`} defaultMessage={'Cancel'}/>
            </button>
            <button
              className={styles.btnSave}
              onClick={() => {
                handleAction();
                handleCloseModal();
              }}
            >
              <FormattedMessage id={`${prefix}-btn-continue`} defaultMessage={'Continue'}/>
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopupDocsWarning;